import { motion } from "framer-motion";
import womanIllustration from "./assets/custom-dev-illustration.svg";

const HeroSection = () => {
  return (
    <section className="max-w-7xl mx-auto font-poppins px-6 py-3 grid grid-cols-12 items-center gap-8">
      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="col-span-12 md:col-span-6"
      >
        <p className="text-sm font-semibold tracking-wider text-green-700 uppercase mb-4">
          Custom Development
        </p>

        <h1 className="text-4xl font-bold text-black mb-6 leading-tight">
          Built exactly how <br /> you need it
        </h1>

        <p className="text-gray-700 text-base leading-relaxed max-w-lg">
          We build tailored software solutions designed to fit your unique
          business needs. From concept to launch, our expert developers deliver
          scalable, high-performance systems. Partner with us to turn your ideas
          into powerful, custom-built applications.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
        className="col-span-12 md:col-span-6 relative"
      >
        <img
          src={womanIllustration}
          alt="Custom development illustration"
          className="w-full max-w-[450px] mx-auto"
        />
      </motion.div>
    </section>
  );
};

export default HeroSection;